export const capitalizeFirstLetterOfEachWord = (str: string): string => {
  const words = str.split(' ');
  const capitalisedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalisedWords.join(' ');
};
